import {Tailwind} from '@wandb/weave/components/Tailwind';
import {ApolloQueryResult} from 'apollo-client';
import React from 'react';

import {EntityQuery} from '../../generated/graphql';
import {TeamSettingsPageEntity} from '../../graphql/teamQuery';
import EntityRateLimitInput from './EntityRateLimitInput';

type EntityRateLimitsProps = {
  entity: TeamSettingsPageEntity | EntityQuery['entity'];
  onUpdate: () => Promise<ApolloQueryResult<EntityQuery>>;
};

const EntityRateLimits = ({entity, onUpdate}: EntityRateLimitsProps) => (
  <Tailwind>
    <div className="my-4 text-base text-moon-500">
      Set to 0 or empty for default, -1 to disable user.
    </div>
    <EntityRateLimitInput
      key={entity?.rateLimits?.graphql} // to refetch when paid status change updates rate limits
      originalLimit={entity?.rateLimits?.graphql ?? 0}
      entityName={entity?.name ?? ''}
      limitTitle="Graphql"
      limitName="graphql"
      limitDescription="Number of requests per second for graphql from UI (read & write). This is at entity level."
      onUpdate={onUpdate}
    />
    <EntityRateLimitInput
      key={entity?.rateLimits?.sdkGraphql} // to refetch when paid status change updates rate limits
      originalLimit={entity?.rateLimits?.sdkGraphql ?? 0}
      entityName={entity?.name ?? ''}
      limitTitle="SDK graphql"
      limitName="sdkGraphql"
      limitDescription="Number of requests per second for graphql from SDK (read & write). This is at entity level."
      onUpdate={onUpdate}
    />
    <EntityRateLimitInput
      key={entity?.rateLimits?.filestreamCount} // to refetch when paid status change updates rate limits
      originalLimit={entity?.rateLimits?.filestreamCount ?? 0}
      entityName={entity?.name ?? ''}
      limitTitle="Filestream count"
      limitName="filestreamCount"
      limitDescription="Number of requests per second for SDK filestream update (write). This entity-level limit overrides the project-level filestream count rate limit when it's lower. Project-level limits can be adjusted on each project's overview page."
      onUpdate={onUpdate}
    />
    <EntityRateLimitInput
      key={entity?.rateLimits?.filestreamSize} // to refetch when paid status change updates rate limits
      originalLimit={entity?.rateLimits?.filestreamSize ?? 0}
      entityName={entity?.name ?? ''}
      limitTitle="Filestream size"
      limitName="filestreamSize"
      limitDescription="Total request size (MB) per second for SDK filestream update (write). This entity-level limit overrides the project-level filestream size rate limit when it's lower. Project-level limits can be adjusted on each project's overview page."
      onUpdate={onUpdate}
    />
    <EntityRateLimitInput
      key={entity?.rateLimits?.sdkGraphqlQuerySeconds} // to refetch when paid status change updates rate limits
      originalLimit={entity?.rateLimits?.sdkGraphqlQuerySeconds ?? 0}
      entityName={entity?.name ?? ''}
      limitTitle="SDK graphql query seconds"
      limitName="sdkGraphqlQuerySeconds"
      limitDescription="Number of DB query seconds per second for SDK graphql Project query (read). This is at entity level. This entity-level limit overrides the project-level sdkGraphqlQuerySeconds rate limit when it's lower. Project-level limits can be adjusted on each project's overview page."
      onUpdate={onUpdate}
    />
  </Tailwind>
);

export default EntityRateLimits;
